import CreditRechargeButtonNode from "./CreditRechargeButtonNode";

export default function BuyCredits({
  channel,
  packs,
  loading,
  error
}) {
  return (
    <div style={styles.wrapper}>
      
      <h2 style={styles.heading}>
        Buy {channel?.toUpperCase()} Credits
      </h2>

      <p style={styles.subHeading}>
        Scale your communication effortlessly
      </p>

      {loading && <div style={styles.info}>Loading...</div>}
      {error && <div style={styles.error}>{error}</div>}

      <div style={styles.grid}>
        {packs.map((p, index) => {
          const isPopular = index === 1; // Highlight middle pack

          return (
            <div
              key={p.id}
              style={{
                ...styles.card,
                ...(isPopular && styles.popularCard)
              }}
            >
              {isPopular && (
                <div style={styles.badge}>
                  MOST POPULAR
                </div>
              )}

              <div style={styles.packName}>
                {p.packName}
              </div>

              <div style={styles.price}>
                ₹ {(p.amountPaise / 100).toFixed(2)}
              </div>

              <div style={styles.credits}>
                {p.credits.toLocaleString()} credits
              </div>

              <div style={styles.divider} />

              <CreditRechargeButtonNode pack={p} />
            </div>
          );
        })}
      </div>
    </div>
  );
}const styles = {
  wrapper: {
    padding: 30,
    background: "#f8fafc",
    
    fontFamily: "Inter, sans-serif"
  },

  heading: {
    marginBottom: 4,
    fontSize: 26,
    fontWeight: 700
  },

  subHeading: {
    marginBottom: 30,
    color: "#64748b",
    fontSize: 14
  },

  info: {
    marginBottom: 15
  },

  error: {
    color: "red",
    marginBottom: 15
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill,minmax(250px,1fr))",
    gap: 20
  },

  card: {
    position: "relative",
    background: "#ffffff",
    borderRadius: 16,
    padding: 24,
    boxShadow: "0 8px 25px rgba(0,0,0,0.05)",
    border: "1px solid #e5e7eb",
    transition: "0.3s ease"
  },

  popularCard: {
    border: "2px solid #4f46e5",
    transform: "scale(1.03)"
  },

  badge: {
    position: "absolute",
    top: -10,
    right: 20,
    background: "#4f46e5",
    color: "#fff",
    padding: "4px 10px",
    fontSize: 11,
    borderRadius: 20,
    fontWeight: 600
  },

  packName: {
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 10
  },

  price: {
    fontSize: 28,
    fontWeight: 700,
    marginBottom: 6
  },

  credits: {
    color: "#475569",
    fontSize: 14,
    marginBottom: 15
  },

  divider: {
    height: 1,
    background: "#f1f5f9",
    marginBottom: 15
  }
};